import React, { FunctionComponent } from "react"
import BadTicketPositiveResponsesTypes from "../types/BadTicketPositiveResponsesTypes"
import PositiveResponseService from "../utils/PositiveResponseService"
import { FormControl, Table } from "react-bootstrap"
import tableItems from "../utils/tableItems"
import BadTicketPositiveResponsesListContextMenu from "./BadTicketPositiveResponsesListContextMenu/BadTicketPositiveResponsesListContextMenu"
import PositiveResponseHashService from "../utils/PositiveResponseHashService"
import TableIdentifierTypes from "../types/TableIdentifierTypes"
import "./BadTicketPositiveResponsesList.css"

const BadTicketPositiveResponsesList: FunctionComponent<{}> = () => {

    const { state, manageState } = PositiveResponseService
    const { badTicketPositiveResponses, busyId, allChecked } = state
    const { lookupHashTableItem, updateHashTableItem, checkOrUncheckAll } = PositiveResponseHashService

    const getTableData = (btpr: BadTicketPositiveResponsesTypes, key: string, i: number, j: number, isChecked: boolean) => {
        //@ts-ignore
        const data = btpr[key]
        const isFirst = j === 0
        const isLast = j === tableItems.length - 1
        return (
            <div className={`BadTicketPositiveResponsesListTDInner ${isFirst ? "BadTicketPositiveResponsesListTDInnerFirst" : isLast ? "BadTicketPositiveResponsesListTDInnerLast" : ""}`}>
                {isFirst && <div className="BadTicketPositiveResponsesListTDInnerCheckbox">
                    <FormControl
                        checked={isChecked}
                        onChange={() => null}
                        type="checkbox"
                    />
                </div>}
                <p>{data}</p>
                {isLast &&
                    <div className="BadTicketPositiveResponsesListContextMenuWrapper">
                        <BadTicketPositiveResponsesListContextMenu
                            btpr={btpr}
                        />
                    </div>
                }
            </div>
        )
    }

    const showOrHideContextMenu = (TicketPositiveResponseId: number, show: boolean) => {
        let elem: HTMLElement | any = document.getElementById(`f508d09c-c1c3-468a-922f-714b3c85589e-${TicketPositiveResponseId}`)
        if (elem) {
            elem.style.display = `${show ? "flex" : `${busyId === TicketPositiveResponseId ? "flex" : "none"}`}`
        }
    }

    const getDataFromReference = (id: number, key: string, tableIdentifier: TableIdentifierTypes) => {
        const hashTableItem = lookupHashTableItem(tableIdentifier, id)
        if (hashTableItem) {
            return hashTableItem[1][key]
        }
        return "*NA*"
    }


    return (
        <div className="BadTicketPositiveResponsesList">
            <Table id="bad-ticket-positive-response-list-table" striped bordered>
                <thead id="bad-ticket-positive-response-list-table-header">
                    <tr>
                        {tableItems.map((item, i) =>
                            <th
                                key={i}
                            // style={{ width: item.width ? item.width : "unset" }}
                            >
                                <div className="BadTicketPositiveResponsesListTHInner">
                                    {i === 0 && <div className="BadTicketPositiveResponsesListTHInnerInput">
                                        <FormControl
                                            checked={allChecked}
                                            onChange={() => checkOrUncheckAll()}
                                            type="checkbox"
                                        />
                                    </div>}
                                    {item.title}
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {badTicketPositiveResponses.map((btpr, i) => {
                        let isChecked = false
                        //@ts-ignore
                        const tableItem = lookupHashTableItem("btprTable", btpr.TicketPositiveResponseId)
                        if (tableItem) {
                            isChecked = tableItem[2].checked
                        }
                        return (
                            <tr className="BadTicketPositiveResponsesListTR" key={i}>
                                {tableItems.map((item, j) =>
                                    <td
                                        className="BadTicketPositiveResponsesListTD"
                                        key={j}
                                        //@ts-ignore
                                        onMouseEnter={() => showOrHideContextMenu(btpr.TicketPositiveResponseId, true)}
                                        //@ts-ignore
                                        onMouseLeave={() => showOrHideContextMenu(btpr.TicketPositiveResponseId, false)}
                                        onClick={() => {
                                            if (j !== tableItems.length - 1) {
                                                let updatedTableItem = tableItem
                                                updatedTableItem[2].checked = !isChecked
                                                updateHashTableItem("btprTable", updatedTableItem)
                                                manageState([{key: "allChecked", value: false}])
                                            }
                                        }}
                                    >
                                        {/*@ts-ignore*/}
                                        {item.table.identifier ? getDataFromReference(btpr.Utilityid, item.table.key, item.table.identifier) : getTableData(btpr, item.key, i, j, isChecked)}
                                    </td>
                                )}
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default BadTicketPositiveResponsesList